import type { OrgSubscription } from "@/interfaces/organization";
import { apiClient } from "@/lib/apiClient";

/** GET /admin/subscriptions/:id — the projection plus its renewal history. GFG-only. */
export async function fetchOrgSubscription(
  organizationId: number,
): Promise<{ success: boolean; subscription: OrgSubscription | null }> {
  const { data } = await apiClient.get<{ success: boolean; subscription: OrgSubscription | null }>(
    `/admin/subscriptions/${organizationId}`,
  );
  return data;
}
